const CAMPAIGN_PARAMS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'utm_id', 'fbclid', 'gclid'];

/** Carries standard campaign parameters already present on the landing URL over to checkout. */
export function buildCheckoutUrl(base: string, search: string): string {
  const incoming = new URLSearchParams(search);
  const url = new URL(base);
  let changed = false;
  CAMPAIGN_PARAMS.forEach((key) => {
    const value = incoming.get(key);
    if (value) {
      url.searchParams.set(key, value);
      changed = true;
    }
  });
  return changed ? url.toString() : base;
}
